module.exports = __webpack_public_path__ + "static/media/ophos-software.be0c2443.svg";